import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Phone, User, LogOut } from 'lucide-react';
import LanguageSwitcher from './LanguageSwitcher';
import { useLanguage } from '../LanguageContext';
import { toast } from 'sonner';
import { Button } from './ui/button';

const Navbar = () => {
  const navigate = useNavigate();
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const { t } = useLanguage();

  useEffect(() => {
    const token = localStorage.getItem('customerToken');
    const customerData = localStorage.getItem('customerData');
    
    if (token && customerData) {
      setIsLoggedIn(true);
      try {
        const data = JSON.parse(customerData);
        setCustomerName(data.name || 'Client');
      } catch (e) {
        console.error('Error parsing customer data:', e);
      }
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('customerToken');
    localStorage.removeItem('customerData');
    setIsLoggedIn(false);
    setCustomerName('');
    toast.success('Déconnexion réussie');
  };

  return (
    <header className="fixed top-0 w-full z-50 bg-black/80 backdrop-blur-md border-b border-gold/20">
      <div className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <a href="/" className="flex items-center space-x-2 cursor-pointer hover:opacity-80 transition-opacity">
            <div className="w-12 h-12 flex items-center justify-center">
              <img 
                src="/logo.png" 
                alt="Luxury Transfer Service LTX" 
                className="w-12 h-12 object-contain"
              />
            </div>
            <span className="text-xl md:text-2xl font-bold bg-gradient-to-r from-gold to-amber-400 bg-clip-text text-transparent">
              LTX
            </span>
          </a>
          <div className="flex items-center space-x-4">
            <a 
              href="tel:+3223150254" 
              className="flex items-center gap-2 px-3 py-2 border border-gold/30 rounded-full text-gold hover:bg-gold/10 transition-all"
            >
              <Phone className="w-4 h-4" />
              <span className="font-semibold text-sm md:text-base">+32 2 315 02 54</span>
            </a>
            <LanguageSwitcher />
            <nav className="hidden md:flex items-center space-x-6">
              <a href="/#services" className="text-gray-300 hover:text-gold transition-colors">{t('header.services')}</a>
              <a href="/#fleet" className="text-gray-300 hover:text-gold transition-colors">{t('header.fleet')}</a>
              <a href="/#about" className="text-gray-300 hover:text-gold transition-colors">{t('header.about')}</a>
              
              {isLoggedIn ? (
                <>
                  <button 
                    onClick={() => navigate('/customer/dashboard')}
                    className="flex items-center gap-2 text-gold hover:text-amber-400 transition-colors"
                  >
                    <User className="w-4 h-4" />
                    <span>{customerName}</span>
                  </button>
                  <button 
                    onClick={handleLogout}
                    className="flex items-center gap-2 text-gray-300 hover:text-red-400 transition-colors"
                  >
                    <LogOut className="w-4 h-4" />
                    <span>Déconnexion</span>
                  </button>
                </>
              ) : (
                <>
                  <button 
                    onClick={() => navigate('/customer/login')}
                    className="text-gray-300 hover:text-gold transition-colors"
                  >
                    Connexion
                  </button>
                  <Button 
                    onClick={() => navigate('/customer/signup')}
                    className="bg-gradient-to-r from-gold to-amber-600 hover:from-amber-600 hover:to-gold text-black font-semibold"
                  >
                    Inscription
                  </Button>
                </>
              )}
            </nav>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Navbar;